var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loanDetail"},[_c('div',{staticClass:"box",on:{"click":_vm.apply}},[_c('h3',[_vm._v("汇农服公众号上线啦!")]),_c('span',[_vm._v("2024年10月13日")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }